<template>
  <header
    class="site-header"
    :style="headerStyle"
    @mouseenter="isHovering = true"
    @mouseleave="handleLeave"
  >
    <div class="topbar" :class="{ 'is-overlay': isOverlayMode }">
      <div class="container topbar-inner">
        <span>{{ topbarText }}</span>
        <span>
          <span>{{ hotlineText }}: {{ phone.landline }}</span>
          <span style="margin-left: 25px">Email: contact@hbtran.com</span>
        </span>
      </div>
    </div>

    <div
      class="nav-shell"
      :class="{
        'is-active': !isOverlayMode || isHovering || hovered !== '' || mobileMenuOpen,
        'is-overlay': isOverlayMode && !isHovering && hovered === '' && !mobileMenuOpen,
        'menu-open': mobileMenuOpen
      }"
    >
      <div class="container nav-row">
        <router-link class="brand" :class="{ 'is-en-brand': locale !== 'zh-CN' }" to="/">
          <img alt="HB" src="/logo.png" />
          <div>
            <strong>{{ companyName }}</strong>
            <span>JIANGSU HONGBANG TRANSFORMER CO., LTD.</span>
          </div>
        </router-link>

        <button
          type="button"
          class="mobile-menu-btn"
          :class="{ active: mobileMenuOpen }"
          :aria-expanded="mobileMenuOpen ? 'true' : 'false'"
          aria-label="Toggle navigation"
          @click.stop="toggleMobileMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div class="nav-right" :class="{ open: mobileMenuOpen }">
          <nav class="nav">
            <div
              v-for="group in navGroups"
              :key="group.path"
              class="nav-item"
              @mouseenter="hovered = group.path"
            >
              <router-link :class="{ active: isActive(group) }" :to="group.path" @click.native="closeMenus">
                {{ $pick(group.label) }}
              </router-link>

              <div v-if="group.children && (hovered === group.path || mobileMenuOpen)" class="dropdown">
                <router-link
                  v-for="item in group.children"
                  :key="item.path"
                  :to="item.path"
                  @click.native="closeMenus"
                >
                  {{ $pick(item.label) }}
                </router-link>
              </div>
            </div>
          </nav>

          <div class="nav-tools">
            <button type="button" class="lang-switch" :title="localeSwitchTitle" @click.stop="toggleLocale">
              <img :src="!isOverlayMode || isHovering || hovered !== '' || mobileMenuOpen ? b : w" alt="Lang" />
              <span class="lang-text">{{ localeBadge }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { navGroups, phoneNumbers } from "../../data/site";
import b from '../../assets/globe-o-24.png'
import w from '../../assets/globe-o-24-w.png'
export default {
  name: "SiteHeader",
  data() {
    return {
      hovered: "",
      b,
      w,
      isHovering: false,
      isScrolled: false,
      horizontalScroll: typeof window === "undefined" ? 0 : window.scrollX,
      viewportWidth: typeof window === "undefined" ? 1200 : window.innerWidth,
      navGroups,
      phone: phoneNumbers,
      mobileMenuOpen: false
    };
  },
  computed: {
    topbarText() {
      return this.locale === "zh-CN"
        ? "欢迎访问江苏宏邦变压器有限公司官网"
        : "Welcome to Jiangsu Hongbang Transformer Website";
    },
    hotlineText() {
      return this.locale === "zh-CN" ? "服务热线" : "Hotline";
    },
    companyName() {
      return this.locale === "zh-CN"
        ? "江苏宏邦变压器有限公司"
        : "Jiangsu Hongbang Transformer Co., Ltd.";
    },
    usesTabletSolidHeader() {
      return this.viewportWidth > 760 && this.viewportWidth <= 900;
    },
    headerStyle() {
      if (this.viewportWidth <= 900) {
        return {};
      }

      return {
        transform: `translateX(-${this.horizontalScroll}px)`
      };
    },
    isOverlayMode() {
      return !this.$route.meta.solidHeader && !this.isScrolled && !this.usesTabletSolidHeader;
    },
    localeSwitchTitle() {
      return this.locale === "zh-CN" ? "切换到英文" : "Switch to Chinese";
    },
    localeBadge() {
      return this.locale === "zh-CN" ? "中" : "EN";
    }
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    document.body.classList.remove("mobile-menu-open");
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 24;
      this.horizontalScroll = window.scrollX || 0;
    },
    handleResize() {
      this.viewportWidth = window.innerWidth;
      this.horizontalScroll = window.scrollX || 0;
    },
    handleLeave() {
      this.isHovering = false;
      if (!this.mobileMenuOpen) {
        this.hovered = "";
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      document.body.classList.toggle("mobile-menu-open", this.mobileMenuOpen);
    },
    closeMenus() {
      this.hovered = "";
      this.isHovering = false;
      this.mobileMenuOpen = false;
      document.body.classList.remove("mobile-menu-open");
    },
    toggleLocale() {
      this.$setLocale(this.locale === "zh-CN" ? "en-US" : "zh-CN");
    },
    isActive(group) {
      if (group.path === "/") {
        return this.$route.path === "/";
      }
      return this.$route.path.indexOf(group.path) === 0;
    }
  },
  watch: {
    $route() {
      this.closeMenus();
    }
  }
};
</script>

<style scoped>
.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 90;
  pointer-events: none;
}

.site-header * {
  pointer-events: auto;
}

.topbar {
  background: rgba(0, 31, 65, 0.72);
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  transition: background-color 0.25s ease, backdrop-filter 0.25s ease;
}

.topbar.is-overlay {
  background: transparent;
}

.topbar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 38px;
  gap: 18px;
}

.nav-shell {
  background: transparent;
  transition: background-color 0.25s ease, box-shadow 0.25s ease, backdrop-filter 0.25s ease;
}

.nav-shell.is-overlay {
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
}

.nav-shell.is-active {
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 8px 24px rgba(15, 35, 64, 0.08);
  backdrop-filter: blur(12px);
}

.nav-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 92px;
}

.brand {
  position: relative;
  z-index: 13;
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  color: #ffffff;
  transition: color 0.25s ease, transform 0.3s ease;
}

.nav-shell.is-active .brand {
  color: var(--brand-blue-deep);
}

.brand:hover {
  transform: translateY(-1px);
}

.brand img {
  width: 50px;
}

.brand strong {
  display: block;
  font-size: 30px;
  line-height: 1.2;
  color: #ffffff;
  -webkit-text-fill-color: currentColor;
  white-space: nowrap;
}

.nav-shell.is-active .brand strong {
  color: #0f57a8;
  background: linear-gradient(90deg, #0f57a8 0%, #1a6fcb 52%, #4f64b8 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.brand span {
  display: block;
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
  letter-spacing: 0.08em;
  transition: color 0.25s ease;
}

.nav-shell.is-active .brand span {
  color: var(--muted);
}

.nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 18px;
  min-width: 0;
  flex: 1 1 auto;
}

.mobile-menu-btn {
  position: relative;
  z-index: 13;
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;
  width: 44px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  cursor: pointer;
  transition: border-color 0.25s ease, background-color 0.25s ease, transform 0.25s ease;
}

.mobile-menu-btn span {
  width: 18px;
  height: 2px;
  border-radius: 999px;
  background: currentColor;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.nav-shell.is-active .mobile-menu-btn {
  color: var(--brand-blue-deep);
  border-color: var(--line);
  background: #ffffff;
}

.mobile-menu-btn.active span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.mobile-menu-btn.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.nav {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 4px;
  min-width: 0;
}

.nav-item {
  position: relative;
  flex: 0 0 auto;
}

.nav-item > a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 92px;
  padding: 0 14px;
  color: rgba(255, 255, 255, 0.96);
  font-size: 15px;
  font-weight: 500;
  text-shadow: 0 1px 18px rgba(0, 0, 0, 0.24);
  transition: color 0.25s ease, background-color 0.25s ease, transform 0.25s ease;
}

.nav-shell.is-active .nav-item > a {
  color: #1b2a3b;
  text-shadow: none;
}

.nav-item > a.active,
.nav-item > a:hover {
  color: var(--brand-blue);
  transform: translateY(-1px);
}

.nav-item > a.active::after,
.nav-item > a:hover::after {
  content: "";
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 20px;
  height: 2px;
  background: var(--brand-blue);
}

.nav-shell.is-overlay .nav-item > a.active,
.nav-shell.is-overlay .nav-item > a:hover {
  color: #ffffff;
}

.nav-shell.is-overlay .nav-item > a.active::after,
.nav-shell.is-overlay .nav-item > a:hover::after {
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.4);
}

.dropdown {
  position: absolute;
  top: calc(100% - 8px);
  left: 0;
  min-width: 220px;
  padding: 10px 0;
  background: #ffffff;
  border: 1px solid var(--line);
  box-shadow: var(--shadow);
}

.dropdown a {
  display: block;
  padding: 10px 18px;
  font-size: 14px;
  color: #334155;
  white-space: nowrap;
}

.dropdown a:hover {
  background: #f5f8fd;
  color: var(--brand-blue);
}

.nav-tools {
  position: relative;
  z-index: 4;
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.lang-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 66px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  background: transparent;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.25s ease;
}

.nav-shell.is-active .lang-switch {
  color: #4a5565;
  border-color: var(--line);
  background: #ffffff;
}

.lang-switch:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.08);
}

.nav-shell.is-active .lang-switch:hover {
  border-color: var(--brand-blue);
  background: rgba(26, 111, 203, 0.08);
}

.lang-icon {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 1.8px solid currentColor;
  border-radius: 50%;
}

.lang-icon::before,
.lang-icon::after {
  content: "";
  position: absolute;
  inset: 50% auto auto 50%;
  transform: translate(-50%, -50%);
}

.lang-icon::before {
  width: 1.8px;
  height: 18px;
  background: currentColor;
}

.lang-icon::after {
  width: 18px;
  height: 1.8px;
  background: currentColor;
  box-shadow: 0 -5px 0 0 currentColor, 0 5px 0 0 currentColor;
}

.lang-text {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

@media (max-width: 1240px) {
  .nav-item > a {
    padding: 0 10px;
    font-size: 14px;
  }
}

@media (min-width: 901px) {
  .site-header {
    min-width: 1280px;
  }
}

@media (max-width: 1600px) {
  .nav-row {
    min-height: 76px;
    padding: 10px 0;
  }

  .brand {
    margin-left: 0;
  }

  .brand img {
    width: 50px;
    height: auto;
  }

  .brand strong {
    font-size: 20px !important;
  }

  .mobile-menu-btn {
    display: inline-flex;
  }

  .nav-right {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 12;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    padding: 112px max(22px, calc((100vw - 420px) / 2)) 34px;
    background: #ffffff;
    box-shadow: none;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-12px);
    transition: opacity 0.24s ease, transform 0.24s ease, visibility 0.24s ease;
    overflow-y: auto;
  }

  .nav-right.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .nav-item > a {
    min-height: 48px;
    justify-content: flex-start;
    width: 100%;
    padding: 0 6px;
    color: #1b2a3b;
    border-bottom: 1px solid #edf1f6;
    text-shadow: none;
  }

  .nav {
    display: grid;
    gap: 0;
    justify-content: stretch;
  }

  .nav-item > a.active::after,
  .nav-item > a:hover::after {
    left: 0;
    right: 0;
    bottom: 6px;
    width: auto;
  }

  .nav-tools {
    margin-top: 20px;
    justify-content: flex-start;
  }

  .dropdown {
    position: static;
    min-width: 0;
    margin: 0;
    padding: 8px 0 12px 18px;
    border: 0;
    box-shadow: none;
    background: transparent;
  }

  .dropdown a {
    padding: 9px 0;
    color: #5b6675;
    white-space: normal;
  }

  .lang-switch {
    width: max-content;
    color: #4a5565;
    border-color: var(--line);
    background: #ffffff;
  }
}

@media (min-width: 761px) and (max-width: 1837px) {
  .brand.is-en-brand strong {
    font-size: 19px !important;
  }
}

@media (max-width: 760px) {
  .site-header {
    pointer-events: auto;
  }

  .topbar {
    display: none;
  }

  .nav-shell.is-overlay {
    background: rgba(3, 20, 39, 0.38);
    backdrop-filter: blur(8px);
  }

  .nav-shell.menu-open {
    background: #ffffff;
    box-shadow: 0 8px 24px rgba(15, 35, 64, 0.08);
    backdrop-filter: none;
  }

  .topbar-inner {
    flex-direction: column;
    justify-content: center;
    padding: 8px 0;
  }

  .nav-row {
    min-height: 64px;
  }

  .brand {
    align-items: center;
    max-width: calc(100% - 56px);
    gap: 8px;
  }

  .brand img {
    width: 35px;
  }

  .brand strong {
    font-size: 15px !important;
    line-height: 1.25;
  }

  .brand span {
    font-size: 8px;
  }

  .nav-right {
    width: 100%;
    max-width: 100%;
    padding: 86px 24px 28px;
  }
}

@media (min-width: 761px) and (max-width: 900px) {
  .topbar.is-overlay {
    background: rgba(0, 31, 65, 0.72);
    backdrop-filter: blur(8px);
  }

  .nav-shell.is-overlay {
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 8px 24px rgba(15, 35, 64, 0.08);
    backdrop-filter: blur(12px);
  }

  .nav-shell.is-overlay .brand {
    color: var(--brand-blue-deep);
  }

  .nav-shell.is-overlay .brand strong {
    color: #0f57a8;
    background: linear-gradient(90deg, #0f57a8 0%, #1a6fcb 52%, #4f64b8 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .nav-shell.is-overlay .brand span {
    color: var(--muted);
  }

  .nav-shell.is-overlay .mobile-menu-btn {
    color: var(--brand-blue-deep);
    border-color: var(--line);
    background: #ffffff;
  }
}

@media (max-width: 420px) {
  .nav-right {
    padding-left: 18px;
    padding-right: 18px;
  }

  .nav-item > a {
    min-height: 46px;
    font-size: 15px;
  }
}
</style>
